import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import AboutPage from "./components/Pages/AboutPage";
import CrewPage from "./components/Pages/CrewPage";
import ReservationPage from "./components/Pages/ReservationPage";
import Kepler22b from "./components/Pages/Kepler22b";
import MainWrapper from "./components/MainWrapper";

const staticFolder = '/above'

function App() {
  return (
    <div className="App">
      <Router basename={staticFolder}>
        <Routes>
          <Route path={"/"} element={<MainWrapper />} />
          <Route path={"/AboutPage"} element={<AboutPage />} />
          <Route path={"/CrewPage"} element={<CrewPage />} />
          <Route path={"/ReservationPage"} element={<ReservationPage />} />
          <Route path={"/Kepler22b"} element={<Kepler22b />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
